import angular from 'angular';
// Css
import 'angular-material/angular-material.css';
// Router config
import routesConfig from './routes';
// SCR run
import scrRun from './run';
// App modules
import core from './core/core.module';
import dependencies from './dependencies/dependencies.module';
import layout from './layout/layout.module';
import services from './services/services.module';
import filters from './filters/filters.module';
import directives from './directives/directives.module';
import components from './components/components.module';
import modules from './modules/modules.module';
import './index.scss';
import 'zone.js';
angular
    .module('app', [
    core,
    dependencies,
    layout,
    services,
    filters,
    directives,
    components,
    modules
])
    .config(routesConfig)
    .run(scrRun);
angular.bootstrap(document.body, ['app'], { strictDi: true });
